import React, { Component } from 'react';
import { Button } from 'antd';
import localDb from '@util/localDb';
import { BackBtn } from '@comm/BackBtn';
import ModalReject from './ModalReject';
import ModalPurchase from './ModalPurchase';

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rejectVisible: false,
      transferVisible: false,
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {}

  // 退回
  handleRejectVisible = flag => {
    this.setState({
      rejectVisible: !!flag,
    });
  };

  // 移交
  handleTransferVisible = flag => {
    this.setState({
      transferVisible: !!flag,
    });
  };

  handlePurchase = params => {
    const { data } = this.props;
    this.props.doTask('transfer', '', { ...params, uuid: data.uuid });
    this.handleTransferVisible(false);
  };

  // 通过按钮，不同流程有不同的特殊操作
  handleNext = () => {
    const {
      data: {
        instance: { currentActivity },
      },
      doTask,
      op,
    } = this.props;

    switch (op) {
      // 采购
      case 'purchase':
        if (currentActivity.name === '采购执行') {
          this.handleTransferVisible(true);
        } else {
          doTask('next');
        }
        break;
      // 默认
      default:
        doTask('next');
        break;
    }
  };

  handleTransfer = () => {
    this.handleTransferVisible(true);
  };

  /**
   * 判断流程中的用户是否有收回按钮
   */
  isAuditor = (activities, currentUser) => {
    return activities.some((item, index) => {
      return (
        (this.userUuid === item.processor || item.processor.indexOf(this.userUuid) !== -1) &&
        activities[index + 1] &&
        currentUser.uuid === activities[index + 1].uuid
      );
    });
  };

  handleReturn = params => {
    this.props.doTask('return', params);
    this.handleRejectVisible(false);
  };

  changeButton = () => {
    const { data, doTask } = this.props;
    const instance = data.instance || {};
    const currentUser = instance.currentActivity || {};
    const activities = instance.activities || [];
    // status:(0,流程进行中；1,流程结束；2.废弃)
    // activities:status:(0,未开始；1,正在进行；2.结束)

    // 审核开关(会签情况)
    const examineFlag =
      currentUser.messages &&
      currentUser.messages.some(item => {
        return item.processor === this.userUuid && item.isDone === 0 && item.status === 0;
      });
    if (instance.status !== 0) {
      return null;
    }
    if (examineFlag) {
      // 当前流程审核人打开
      return (
        <span>
          <Button
            icon="arrow-left"
            style={{ marginRight: 10 }}
            onClick={() => this.handleRejectVisible(true)}
          >
            退回
          </Button>
          <Button
            icon="check"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => doTask('next')}
            loading={this.props.isLoading || false}
          >
            通过
          </Button>
          {currentUser.name === '采购执行' ? (
            <Button
              icon="arrow-right"
              type="primary"
              style={{ marginRight: 10 }}
              onClick={this.handleTransfer}
              loading={this.props.isLoading || false}
            >
              转交
            </Button>
          ) : null}

          {data.createUser === this.userUuid && activities[0] && activities[0].status !== 2 ? (
            <Button
              icon="arrow-left"
              style={{ marginRight: 10 }}
              onClick={() => doTask('callback')}
            >
              收回
            </Button>
          ) : null}
        </span>
      );
    }
    if (
      (data.createUser === this.userUuid && activities[0] && activities[0].status !== 2) ||
      this.isAuditor(activities, currentUser)
    ) {
      // 申请人打开
      return (
        <span>
          <Button icon="arrow-left" style={{ marginRight: 10 }} onClick={() => doTask('callback')}>
            收回
          </Button>
        </span>
      );
    }
    return null;
  };

  render() {
    const { rejectVisible, transferVisible } = this.state;
    return (
      <div className="form-open">
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          {this.changeButton()}
        </div>
        <ModalReject
          visible={rejectVisible}
          handleOk={this.handleReturn}
          handleCancel={this.handleRejectVisible}
        />

        <ModalPurchase
          visible={transferVisible}
          handleOk={this.handlePurchase}
          handleCancel={this.handleTransferVisible}
        />
      </div>
    );
  }
}

export default Open;



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/workflow/WorkflowOp.js